import { NavLink } from "react-router"

import { Button } from "@/components/ui/button"

export default function SPLFarmHeader() {
  return (
    <div className="mb-3">
      <NavLink to={"/dashboards/SPL"} end>
        {({ isActive }) => (
          <Button
            variant="outline"
            className={`rounded-r-none ${isActive && "text-accent-foreground"}`}
          >
            SPL Farm Dashboard
          </Button>
        )}
      </NavLink>
      <NavLink to={"/dashboards/SPL/Balances"}>
        {({ isActive }) => (
          <Button
            variant="outline"
            className={`rounded-l-none border-l-0 ${isActive && "text-accent-foreground"}`}
          >
            Farm Balances
          </Button>
        )}
      </NavLink>
    </div>
  )
}
